import classnames from 'classnames'
import BotStatus from 'components/lib/icons/BotStatus'
import RecipientAvatar from 'components/RecipientAvatar'
import useActiveAgentStatus from 'hooks/useActiveAgentStatus'
import { useRecipientResolution } from 'hooks/useRecipientResolution'
import { pathOr } from 'ramda'
import React, { ReactNode } from 'react'

import './style.css'

interface PresenceAvatarProps {
  size?: string,
  id?: number,
  isHidden?: boolean,
  className?: string,
  image?: string
  children?: ReactNode
}

const AgentAvatarAndStatus = ({
  className,
  id,
  image,
  size,
  status
}) => (
  <div className={classnames("drift-widget-presence-avatar", className)}>
    <RecipientAvatar size={size} id={id} image={image} />
    <BotStatus className="drift-widget-agent-status" status={status} />
  </div>
)

const PresenceAvatar = ({
  children = null,
  className,
  id = null,
  isHidden = false,
  image,
  size = 'LARGE',
}: PresenceAvatarProps) => {
  const { recipient } = useRecipientResolution(id)
  const agentAvatar = pathOr(null, ['avatarUrl'], recipient)
  const isBotAvatar = pathOr(false, ['bot'], recipient)
  const status = useActiveAgentStatus(id, recipient.bot)

  if (!agentAvatar && !isBotAvatar) {
    return null
  }

  if (children) {
    return (
      <div
        aria-hidden={isHidden}
        className="drift-widget-agent-presence"
      >
        <AgentAvatarAndStatus
          className={className}
          id={id}
          image={image ?? agentAvatar}
          size={size}
          status={status}
        />
        {children}
      </div>
    )
  }

  return (
    <AgentAvatarAndStatus
      className={className}
      id={id}
      image={image ?? agentAvatar}
      size={size}
      status={status}
    />
  )
}


export default PresenceAvatar
